// Contrast helpers for public salon pages.
// `autoTextColor` returns a guaranteed-readable text colour for any HEX background
// using ITU-R BT.601 luma. We use this to keep form cards readable even when the
// admin picks an unusual `booking_card_bg` in Theme Studio.
export function autoTextColor(hex) {
  if (!hex || typeof hex !== "string") return "#1a1a1a";
  let h = hex.replace("#", "");
  if (h.length === 3) h = h.split("").map((c) => c + c).join("");
  if (h.length !== 6) return "#1a1a1a";
  const r = parseInt(h.slice(0, 2), 16);
  const g = parseInt(h.slice(2, 4), 16);
  const b = parseInt(h.slice(4, 6), 16);
  const luma = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luma > 0.6 ? "#1a1a1a" : "#ffffff";
}

// Returns a coherent set of colours for a public-facing card surface, derived from
// the theme's optional `booking_card_bg` / `booking_card_text_color` overrides.
// Pages such as /booking and /account share the same fields so admins configure
// contrast once and it propagates everywhere.
export function getPublicCardStyle(theme) {
  const bg = theme?.booking_card_bg || "#fff";
  const text = theme?.booking_card_text_color || autoTextColor(bg);
  // Tile / input border colour: subtle, but visible on both light & dark cards.
  const border = text === "#ffffff" ? "rgba(255,255,255,0.22)" : "rgba(0,0,0,0.12)";
  // A slightly recessed surface (used for nested boxes like reward chips).
  const subtle = text === "#ffffff" ? "rgba(255,255,255,0.06)" : "rgba(0,0,0,0.035)";
  return { bg, text, border, subtle };
}
